import { createBaseResponseErrors } from '@/utils/error/responseErrors'
import { createBaseCRUDApi } from '@/api/baseApi'

const TABLE_TIME_AND_LOAD_URL = 'calendar/tables'

const errors = createBaseResponseErrors('таблицу', 'таблиц')

export const TableTimeAndLoadApi = createBaseCRUDApi(TABLE_TIME_AND_LOAD_URL, errors)
